import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags'; 
import { Link } from 'react-router-dom'; // Added Meta Tag npm Package
import { Row, Col, Container, Card, CardBody, CardTitle, Modal, Form, Label, Input, UncontrolledTooltip, Badge } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import axios from 'axios';
import * as url from 'helpers/url_helper';
import { Config, TOAST_OPTIONS, formatDate } from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Select from 'react-select';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { Button} from "reactstrap";
import LoadingOverlay from 'react-loading-overlay';
LoadingOverlay.propTypes = undefined
import BounceLoader from 'react-spinners/BounceLoader'



    const StockMovement = () => {

        toastr.options = TOAST_OPTIONS;

        const [modal_stock, setmodal_stock] = useState(false);
        const [isEdit, setIsEdit] = useState(false);
        const [stockList, setStockList] = useState([]);
        const [isloading, setIsloading] = useState(false)
        

        
        const [code, setCode] = useState('')
        const [address, setAddress] = useState('')
        const [phone, setPhone] = useState('')
        const [email, setEmail] = useState('')
        const [status, setStatus] = useState('')
        const [userId, setUserId] = useState('')
        const [selectedCategories, setSelectedCategories] = useState(null)

        
        const [itemId, setItemId] = useState('')
        const [name, setName] = useState('')
        const [count, setCount] = useState('')
        const [categoryId, setCategoryId] = useState('')
        const [description, setDescription] = useState('')
        const [sku, setSKU] = useState('')
        const [costPrice, setCostPrice] = useState('')
        const [sellPrice, setSellPrice] = useState('')
        const [supplierId, setSupplierId] = useState('')

        const [id, setId] = useState('')
        const [qtyAtHand, setQtyAtHand] = useState(0)
        const [minimumLevel, setMinimumLevel] = useState(0)
        const [reorderQty, setReorderQty] = useState(0)
        const [purchasePrice, setPurchasePrice] = useState(0)
        const [warehouseId, setWarehouseId] = useState('')
        

        const [sId, setSId] = useState('')
        const [sStartDate, setSStartDate] = useState([])
        const [sEndDate, setSEndDate] = useState([])
        const [sName, setSName] = useState('')
        const [sRegionId, setSRegionId] = useState('')
        const [sClusterId, setSClusterId] = useState('')
        const [sSchemeId, setSSchemeId] = useState('')
        const [sAreaId, setSAreaId] = useState('')
        const [sAssetId, setSAssetId] = useState('')
        const [sWarehouseId, setSWarehouseId] = useState('')
        const [sSupplierId, setSSupplierId] = useState('')
        const [sJobCard, setSJobCardId] = useState('')
        const [sCategoryId, setSCategoryId] = useState('')
        const [sMovementType, setSMovementType] = useState('Deduct')

        const [regions, setRegions] = useState([])
        const [clusters, setClusters] = useState([])
        const [areas, setAreas] = useState([])
        const [schemes, setSchemes] = useState([])
        const [assets, setAssets] = useState([])
        const [movementOptions, setMovementOptions] = useState(['Add','Deduct','Adjust'])

        const [itemCategoryOptions, setItemCategoryOptions] = useState([])
        const [supplierOptions, setSupplierOptions] = useState([])
        const [warehouseOptions, setWarehouseOptions] = useState([])
        const [regionOptions, setRegionOptions] = useState([])
        const [countOptions, setCountOptions] = useState([])

        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
        }
        const tog_stock = () => {
          setmodal_stock(!modal_stock);
          removeBodyCss();
        }

        const handleFilterData = async () =>{
            const data = {
                startDate: sStartDate[0]?formatDate(sStartDate[0]):'',
                endDate: sEndDate[0]?formatDate(sEndDate[0]):'',
                name: sName, 
                regionId: sRegionId,
                clusterId: sClusterId,
                areaId: sAreaId,
                schemeId: sSchemeId,
                assetId:sAssetId,
                jobcard: sJobCard,
                movementType: sMovementType,
                categoryId: sCategoryId, 
                warehouseId: sWarehouseId, 
                supplierId: sSupplierId
            }
           try {
              setIsloading(true)
              const r = await axios.post(url.STOCKMOVEMENTFILTER, JSON.stringify(data), Config)
              r.data?setStockList(r.data):setStockList([])
              console.log(r.data)
           } catch (e) {
              console.log('Error while loading stock movement '+e);
           } finally {
              setIsloading(false)
           }
        }
        useEffect(() => {
            if(localStorage.getItem("authWTUser")){
                const obj = JSON.parse(localStorage.getItem("authWTUser"));
                setUserId(obj.id)
            }
  
            axios.get(`${url.ITEMCATEGORIES}`, Config).then((r)=>{
                setItemCategoryOptions(r.data)
            }).catch((e)=>{console.log(e);})
           
            axios.get(`${url.WAREHOUSES}`, Config).then((r)=>{
                setWarehouseOptions(r.data)
            }).catch((e)=>{console.log(e);}) 
            const data = {  }
            axios.post(url.SUPPLIERFILTER, JSON.stringify(data), Config).then((r)=>{ 
                setSupplierOptions(r.data)
              }).catch((e)=>{  
                console.log(e); 
              })
            handleFilterData()
        },[]);

        const getClusters = (u) =>{
            axios.get(`${url.CLUSTERS}?region?${u}`, Config).then((r)=>{ setClusters(r.data); }).catch((e)=>{  console.log(e); });
          }
          const getAreas = (c) =>{
            axios.get(`${url.AREAS}?cluster?${c}`, Config).then((r)=>{ setAreas(r.data); }).catch((e)=>{  console.log(e); });
          }
          const getSchemes = (a) =>{
            axios.get(`${url.SCHEME}?area?${a}`, Config).then((r)=>{ setSchemes(r.data) }).catch((e)=>{ console.log(e) })
          }
          const getAssets = (s) =>{
            const data = {schemeId: s}
            axios.post(url.ASSETSFILTER, JSON.stringify(data), Config).then((r)=>{ setAssets(r.data) }).catch((e)=>{ console.log(e) })
          }
 
        const handleClickAdd = () => {  
            //setIsEdit(false);
            //tog_stock(); 
            //setId('')
            toastr.warning('Stock deduction can only be done when generating work orders')

        }
        const handleSaveInventory = () =>{
            
           
        }

        const columns = [

        {
            dataField: 'movement_date',
            text: 'Date',
            sort: true
        },
        {
            dataField: 'movement_type',
            text: 'Type',
            sort: true
        },
        {
            dataField: 'item_name',
            text: 'Item',
            sort: true
        },
        {
            dataField: 'ref',
            text: 'Reason',
            sort: true
          },
        {
          dataField: 'ref_no',
          text: 'Job No',
          sort: true,
          headerStyle: { textAlign: 'center' },
          style: { textAlign: 'center' } 
        },
        {
            dataField: 'qty',
            text: 'Quantity',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center' } 
          },
          {
            dataField: 'qty_at_hand',
            text: 'Balance',
            sort: true,
            headerStyle: { textAlign: 'center' },
            style: { textAlign: 'center' } 
          },
       
          {
            dataField: 'warehouse',
            text: 'Store Location',
            sort: true
          },
       ];

        const defaultSorted = [{
          dataField: 'sid',
          order: 'desc'
        }];


        return (
            <>
            <LoadingOverlay
                active={isloading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Item Movement | {url.COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title={url.COMPANY} breadcrumbItem="Spare and Materials Movements" />
                        <Row>
                            <Col lg="12">
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">Filter</h5>
                                <CardBody>
                                    <Row className="justify-content-center mb-1">
                                        <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>From</label>
                                                          <Flatpickr
                                                            className="form-control form-control-sm"
                                                            options={{
                                                                dateFormat: "Y-m-d",
                                                                enableTime: false
                                                            }}
                                                            value={sStartDate}
                                                            onChange={(dates)=>setSStartDate(dates)}
                                                            />
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Till </label>
                                                          <Flatpickr
                                                              className="form-control form-control-sm"
                                                              options={{
                                                                  dateFormat: "Y-m-d",
                                                                  enableTime: false
                                                              }}
                                                              value={sEndDate}
                                                              onChange={(dates)=>setSEndDate(dates)}
                                                              />
                                                      </div>
                                                  </Col>
                                 
                                               
                                                 </Row>
                                                 {/*
                                                 <Row className="justify-content-center mb-1">
                                                  <Col xl={2}>
                                                      <div className="mb-3">
                                                          <label>Umbrella</label>
                                                          <select className="form-select form-select-sm" value={sRegionId} onChange={(e)=>{setSRegionId(e.target.value); getClusters(e.target.value)}}>
                                                          <option value=""></option>
                                                          {(regions || []).map((a,k)=>(
                                                            <option key={k} value={a.id}>{a.region}</option>
                                                          ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                  <Col xl={2}>
                                                      <div className="mb-3">
                                                          <label>Cluster</label>
                                                          <select className="form-select form-select-sm" value={sClusterId} onChange={(e)=>{setSClusterId(e.target.value); getAreas(e.target.value)}}>
                                                          <option value=""></option>
                                                          {(clusters || []).map((a,k)=>(
                                                            <option key={k} value={a.id}>{a.cluster}</option>
                                                          ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                  <Col xl={2}>
                                                      <div className="mb-3">
                                                          <label>Area</label>
                                                          <select className="form-select form-select-sm" value={sAreaId} onChange={(e)=>{setSAreaId(e.target.value); getSchemes(e.target.value)}}>
                                                          <option value=""></option>
                                                          {(areas || []).map((a,k)=>(
                                                            <option key={k} value={a.id}>{a.name}</option>
                                                          ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                  <Col xl={2}>
                                                      <div className="mb-3">
                                                          <label>Scheme</label>
                                                          <select className="form-select form-select-sm" value={sSchemeId} onChange={(e)=>{setSSchemeId(e.target.value); getAssets(e.target.value)}}>
                                                          <option value=""></option>
                                                          {(schemes || []).map((a,k)=>(
                                                            <option key={k} value={a.id}>{a.scheme}</option>
                                                          ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                  <Col xl={2}>
                                                      <div className="mb-3">
                                                          <label>Asset</label>
                                                          <select className="form-select form-select-sm" value={sAssetId} onChange={(e)=>setSAssetId(e.target.value)}>
                                                          <option value=""></option>
                                                          {(assets || []).map((a,k)=>(
                                                            <option key={k} value={a.tid}>{a.asset_name}{a.parent_asset_name && ` - ${a.parent_asset_name}`}</option>
                                                          ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                  </Row>
                                                  */}
                                                 <Row className="justify-content-center mb-1">
                                                 <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Search by Name</label>
                                                          <input type='text' className="form-control form-control-sm" value={sName} onChange={(e)=>setSName(e.target.value)} />
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>JobCard</label>
                                                          <input type='text' className="form-control form-control-sm" value={sJobCard} onChange={(e)=>setSJobCardId(e.target.value)} />
                                                      </div>
                                                  </Col>
                                                  <Col xl={2}>
                                                      <div className="mb-3">
                                                          <label>Movement Type</label>
                                                          <select className="form-select form-select-sm" value={sMovementType} onChange={(e)=>setSMovementType(e.target.value)}>
                                                          <option value=""></option>
                                                          {(movementOptions || []).map((a,k)=>(
                                                            <option key={k} value={a}>{a}</option>
                                                          ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                  
                                                  <Col xl={2}>
                                                      <div className="mb-3">
                                                          <label>Warehouse</label>
                                                          <select className="form-select form-select-sm" value={sWarehouseId} onChange={(e)=>setSWarehouseId(e.target.value)}>
                                                          <option value=""></option>
                                                          {(warehouseOptions || []).map((a,k)=>(
                                                            <option key={k} value={a.id}>{a.name}</option>
                                                          ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                             
                                                  
                                                  <Col xl={2}>
                                                      <div className="mb-3">
                                                          <label>Category</label>
                                                          <select className="form-select form-select-sm" value={sCategoryId} onChange={(e)=>setSCategoryId(e.target.value)}>
                                                          <option value=""></option>
                                                          {(itemCategoryOptions || []).map((a,k)=>(
                                                            <option key={k} value={a.id}>{a.name}</option>
                                                          ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                  <Col xl={2}>
                                                      <div className="mb-3">
                                                          <label>Supplier</label>
                                                          <select className="form-select form-select-sm" value={sSupplierId} onChange={(e)=>setSSupplierId(e.target.value)}>
                                                          <option value=""></option>
                                                          {(supplierOptions || []).map((a,k)=>(
                                                            <option key={k} value={a.id}>{a.name}</option>
                                                          ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                              
                                                </Row>
                                       
                                                <Row  className="justify-content-center mb-2 mt-3">
                                                <Col lg={2}> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='primary'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleFilterData()}}
                                                      >
                                                        <i className="mdi mdi-magnify me-1" />
                                                        Search
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                 
                                                  <Col lg={2}> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='success'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleClickAdd()}}
                                                      >
                                                        <i className="mdi mdi-plus me-1" />
                                                        Adjust
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  
                                                </Row>
                                                </CardBody>
                                                </Card>
                        
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">Stock Movement ({stockList.length})</h5>
                                <CardBody>

                                
                                <Modal isOpen={modal_stock} toggle={() => { tog_stock();}} centered>
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ isEdit ? 'Edit ': 'Add ' } {' Movement'}</h5>
                                    <button onClick={() => { setmodal_stock(false);}} className="close" data-dismiss="modal" aria-label="Close"></button>
                                  </div>
                                  <div className="modal-body">
                                    <Row>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Item Name</label>
                                                <input type='text' className="form-control" value={name} onChange={(e)=>setName(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Units</label>
                                                <select className="form-select" value={count} onChange={(e)=>setCount(e.target.value)}>
                                                <option value=""></option>
                                                {(countOptions || []).map((a,k)=>(
                                                    <option key={k} value={a}>{a}</option>
                                                ))}
                                                </select>
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Category</label>
                                                <select className="form-select" value={categoryId} onChange={(e)=>setCategoryId(e.target.value)}>
                                                <option value=""></option>
                                                {(itemCategoryOptions || []).map((a,k)=>(
                                                    <option key={k} value={a.id}>{a.name}</option>
                                                ))}
                                                </select>
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Description</label>
                                                <input type='text' className="form-control" value={description} onChange={(e)=>setDescription(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>SKU</label>
                                                <input type='text' className="form-control" value={sku} onChange={(e)=>setSKU(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>Cost Price</label>
                                                <input type='text' className="form-control" value={costPrice} onChange={(e)=>setCostPrice(e.target.value)} />
                                            </div>
                                        </Col>
                                     
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>Supplier</label>
                                                <select className="form-select" value={supplierId} onChange={(e)=>setSupplierId(e.target.value)} >
                                                    <option value=""></option>
                                                    {(supplierOptions || []).map((a,k)=>(
                                                    <option key={k} value={a.id}>{a.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </Col>
                                        <hr/>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>Quantity at Hand</label>
                                                <input type='text' className="form-control" value={qtyAtHand} onChange={(e)=>setQtyAtHand(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>Minimum Level</label>
                                                <input type='text' className="form-control" value={minimumLevel} onChange={(e)=>setMinimumLevel(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>Re Order Quantity</label>
                                                <input type='text' className="form-control" value={reorderQty} onChange={(e)=>setReorderQty(e.target.value)} />
                                            </div>
                                        </Col>
                                        
                                        <Col md={6}>
                                            <div className="mb-3">
                                                <label>Warehouse</label>
                                                <select className="form-select" value={warehouseId} onChange={(e)=>setWarehouseId(e.target.value)} >
                                                    <option value=""></option>
                                                    {(warehouseOptions || []).map((a,k)=>(
                                                            <option key={k} value={a.id}>{a.name}</option>
                                                          ))}
                                                </select>
                                            </div>
                                        </Col>
                                    </Row>
                                  </div>
                                  
                                  <div className="modal-footer">
                                    {isloading?`Please wait...`:(<>
                                    <button  onClick={() => { tog_stock(); }} className="btn btn-danger" data-dismiss="modal">Close</button>
                                    <button className="btn btn-success" onClick={handleSaveInventory}>Save...</button>
                                    </>)}
                                  </div>
                                </Modal>

                                {stockList && (stockList.length > 0) && (
                                    <>
                                    <ToolkitProvider
                                      keyField="sid"
                                      data={stockList}
                                      columns={ columns }
                                      search
                                    >
                                      { toolkitProps => (
                                          <React.Fragment>
                                            <Row>
                                              <Col xl="12">
                                                <div className="table-responsive">
                                            
                                                <BootstrapTable 
                                                  keyField='sid' 
                                                  data={stockList} 
                                                  columns={ columns } 
                                                  striped
                                                  //hover
                                                  condensed
                                                  bordered={ false }
                                                  noDataIndication="No Records" 
                                                  defaultSorted={ defaultSorted }
                                                  classes={ "table align-middle table-nowrap table-check" }
                                                    {...toolkitProps.baseProps}
                                                  />
                                            </div>
                                            </Col>
                                            </Row>
                                            </React.Fragment>
                                            
                                      )
                                    }
                                  </ToolkitProvider>

                                    </>
                                )}
                                {stockList && (stockList.length < 1) && (
                                    <div className="text-center">
                                        <div className="mb-4">
                                        <i className="mdi mdi-flask-empty-minus-outline text-danger display-4" />
                                        </div>
                                        <div>
                                        <h5>No stock movements found</h5>
                                        <p className="text-muted">
                                                
                                        </p>
                                        </div>
                                    </div>

                                )}
                                </CardBody>
                            </Card>
                            </Col>
                        </Row>

                        
                           

                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default StockMovement;